import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { EnvioComprovanteDTO } from '../../../dtos/envio-comprovante-dto';
import { TipoEnvioComprovanteEnum } from '../../../enums/tipo-envio-comprovante-enum';
import { ChaveValorBooleanInterface } from '../../../util/chave-valor-boolean-interface';
import { Util } from '../../../util/util';
import { CustomDateValidator } from '../../../validators/custom-date-validator';
import { EnvioComprovanteService } from '../envio-comprovante.service';

@Component({
  selector: 'app-envio-comprovante-list',
  templateUrl: './envio-comprovante-list.component.html',
  styleUrls: ['./envio-comprovante-list.component.css']
})
export class EnvioComprovanteListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['dataEnvio', 'sequencial', 'tipoEnvio', 'nomePaciente',
    'emailEnvioPaciente', 'celularEnvioPaciente', 'envioSucesso', 'dscStatusEnvio'];

  formularioDeEnvioDeComprovante: FormGroup;

  filtroEnvioComprovante: EnvioComprovanteDTO = new EnvioComprovanteDTO();

  listaTipoEnvio: string[] = Object.keys(TipoEnvioComprovanteEnum);

  listaStatusEnvioComprovante: ChaveValorBooleanInterface[] = Util.listaStatusEnvioComprovante;

  constructor(private envioComprovanteService: EnvioComprovanteService,
    router: Router, dialog: MatDialog,
    private formBuilder: FormBuilder) {

    super(router, dialog);

    this.formularioDeEnvioDeComprovante = this.formBuilder.group({
      dataInicial: [null],
      dataFinal: [null],
      tipoEnvio: [null],
      cpfPaciente: ['', [CpfCnpjValidator.validate]],
      nomePaciente: ['', [Validators.minLength(3)]],
      emailEnvioPaciente: ['', [Validators.email]],
      celularEnvioPaciente: [''],
      envioSucesso: [null],
      dataNascimentoPaciente: [null],
    }, {
      validator: [CustomDateValidator('dataInicial'),
      CustomDateValidator('dataFinal'),
      CustomDateValidator('dataNascimentoPaciente')],
    });
  }

  ngOnInit() {

    super.ngOnInit();
  }

  reloadData() {

    if (this.filtroEnvioComprovante && this.filtroEnvioComprovante.temCampoSelecionado()) {

      this.envioComprovanteService.procurarEnvioComprovantePorFiltro(this.filtroEnvioComprovante)
        .subscribe(data => {
          // console.log(data)
          this.data = data;
          this.configurarDataSource();
        }, error => {
          console.log(error);
        });
    } else {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });
    }
  }

  onSubmit() {
    this.filtroEnvioComprovante = Object.assign(new EnvioComprovanteDTO(), this.formularioDeEnvioDeComprovante.value);

    this.reloadData();
  }

  limparCampos(): void {

    this.filtroEnvioComprovante = new EnvioComprovanteDTO();

    this.formularioDeEnvioDeComprovante.patchValue(this.filtroEnvioComprovante);

  }

  pattern = Util.pattern;

}
